'use client';
import { Disclosure } from '@headlessui/react';
import { Icon } from '@fm-nx/svg';
import { CldImage } from 'next-cloudinary';
import LinkWrapper from '../link-wrapper/link-wrapper';

export interface JobListItemProps {
    // public_id from cloudinary
    iconSrc?: string;
    title: string;
    summary: string;
    isFirst?: boolean;
    linkHref?: string;
    linkText?: string;
}

export function JobListItem(props: JobListItemProps) {
    const { isFirst = false, iconSrc, title, summary, linkHref, linkText = 'View Details & Apply' } = props;
    return (
        <Disclosure>
            {({ open }) => (
                <div className={`border-b-2 ${isFirst ? 'border-t-2' : ''}`}>
                    <Disclosure.Button className="flex items-center justify-between w-full py-6">
                        <div className="flex items-center">
                            <div className={`aspect-square h-[30px] w-[30px]`}>
                                <CldImage src={`${iconSrc}`} width={30} height={30} alt="" format="svg" />
                            </div>
                            <p className="px-8 mb-0 text-left h-md">{title}</p>
                        </div>
                        <div className="flex items-center">
                            <Icon name="caretThin" color={'black'} direction={open ? 'up' : 'down'} />
                        </div>
                    </Disclosure.Button>
                    <Disclosure.Panel>
                        <div className="mb-6 pl-14">
                            <div className="mt-2 ">{summary}</div>
                            <LinkWrapper
                                href={linkHref}
                                className="inline-block mt-4 mb-0 text-gray-900 uppercase font-headline h5 emdash-push"
                            >
                                {linkText}
                            </LinkWrapper>
                        </div>
                    </Disclosure.Panel>
                </div>
            )}
        </Disclosure>
    );
}

export default JobListItem;
